export default __webpack_public_path__ + "static/media/sadface.db607223.webp";